import React from 'react'
import MapPicker from './MapPicker';

// function MapaTrecho({isModalOpen, alterarLatitudeLongitude}) {

//     return (
//         <div style={{ width: '500px', height: '551px', justifyContent: 'space-between', marginTop: '35px', marginBottom: '15px' }}>            
//             <MapPicker isOpen={isModalOpen} onLocationSelect={alterarLatitudeLongitude} />
//         </div>
//     )
// }

// export default MapaTrecho;
function MapaTrecho({ isOpen, alterarLatitudeLongitude, latitude, longitude }) {
    return (
        // Removido width fixo de 500px para não estourar o modal
        <div style={{
            width: '100%',
            height: '100%',
            marginTop: '35px',
            marginBottom: '15px',
            border: '1px solid #ccc'
        }}>
            <MapPicker isOpen={isOpen} onLocationSelect={alterarLatitudeLongitude}
                       latitude={latitude} longitude={longitude} />
        </div>
    )
}

export default MapaTrecho;